import React, { useContext, useState } from 'react';
import { DatabaseContext } from '../../Controllers/Database';
import { AppConfigContext } from '../../Config/App';
import { LanguageContext } from '../../Data/Context/languageContext';
import parse from 'html-react-parser';

const DeleteBuildModal = () => {
    const { uri_segment } = useContext(AppConfigContext);
    const { processData } = useContext(DatabaseContext);
    const [build_id] = useState(uri_segment());
    const { t } = useContext(LanguageContext);

    const onDeleteBuild = () => {
        const payload = {
            build_id: build_id
        }
        processData(payload, 'delete');
    }

    return (
        <div className="modal fade" role="dialog" tabIndex="-1" id="deleteBuild-modal">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
                    <div className="modal-body purple-bk-darker text-center">
                        {parse(t("delete_modal"))}
                        <button onClick={() => onDeleteBuild()} className='btn btn-danger m-2' type="button" data-bs-dismiss="modal">
                            <i className="fa-solid fa-trash"></i> {t("delete")}</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default DeleteBuildModal;